__turbopack_context__.v({
  "hoursList": "PickupLocationHoursDisclosure-module__7BOdPW__hoursList",
  "hoursListItem": "PickupLocationHoursDisclosure-module__7BOdPW__hoursListItem",
  "hoursListItemDetail": "PickupLocationHoursDisclosure-module__7BOdPW__hoursListItemDetail",
  "root": "PickupLocationHoursDisclosure-module__7BOdPW__root",
});
